"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jszip_1 = __importDefault(require("jszip"));

var xml_1 = require("./xml");

exports.createSAP = function (options) {
  var form = {
    type: 'form',
    attributes: {
      id: 'Form'
    },
    children: [],
    parent: null,
    depth: 1
  };
  var project = {
    attributes: options,
    children: [form],
    depth: 0,
    type: 'project',
    images: {},
    sounds: {}
  };
  form.parent = project;
  return project;
};

exports.importSAP = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var zip, projectXmlFile, projectXml, project, result, extractAssets, _a, _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          if (!(file && file.lastModified && file.name)) {
            throw new Error('Invalid file');
          }

          return [4
          /*yield*/
          , jszip_1.default.loadAsync(file)];

        case 1:
          zip = _c.sent();
          console.log(zip);
          projectXmlFile = zip.file('PROJECT.xml');

          if (projectXmlFile === null) {
            throw new Error('No PROJECT.xml file found');
          }

          return [4
          /*yield*/
          , projectXmlFile.async("text")];

        case 2:
          projectXml = _c.sent();
          return [4
          /*yield*/
          , xml_1.decode(projectXml)];

        case 3:
          project = _c.sent();
          result = __assign(__assign({}, project), {
            images: {},
            sounds: {}
          });

          extractAssets = function extractAssets(folderName) {
            var result = {};
            var promises = [];
            zip.folder(folderName).forEach(function (path, file) {
              promises.push(file.async("blob").then(function (asset) {
                result[path] = asset;
              }));
            });
            return Promise.all(promises).then(function () {
              return result;
            });
          };

          _a = result;
          return [4
          /*yield*/
          , extractAssets('img')];

        case 4:
          _a.images = _c.sent();
          _b = result;
          return [4
          /*yield*/
          , extractAssets('snd')];

        case 5:
          _b.sounds = _c.sent();
          return [2
          /*return*/
          , result];
      }
    });
  });
};

exports.saveSAP = function (project) {
  return __awaiter(void 0, void 0, void 0, function () {
    var output, projectXml, zipAssets;
    return __generator(this, function (_a) {
      output = new jszip_1.default();
      projectXml = xml_1.encode(project);
      output.file('PROJECT.xml', projectXml);

      zipAssets = function zipAssets(assets, folderName) {
        var entries = Object.entries(assets);

        if (entries.length > 0) {
          var folder_1 = output.folder(folderName);
          entries.forEach(function (_a) {
            var assetId = _a[0],
                asset = _a[1];
            return folder_1.file(assetId, asset);
          });
        }
      };

      zipAssets(project.images, 'img');
      zipAssets(project.sounds, 'snd');
      return [2
      /*return*/
      , output.generateAsync({
        type: 'blob'
      })];
    });
  });
};